<template>
    <div>
        <div style="display:flex;display: none;">
            <!-- <div>
          <el-input v-model="searchArr.phone_order" placeholder="手机号/订单号" size="mini" clearable
            :loading="searchLoading" prefix-icon="el-icon-search">
          </el-input>
        </div> -->
            <div style="margin-left:0.2rem">
                <el-popover placement="bottom-start" width="500" ref="renewPopover" v-model="visible">
                    <el-form :model="searchArr" ref="searchForm" label-width="100px" style="margin-left:-0.3rem">
                        <!-- <el-form-item label="代理记账状态" prop="status">
                            <el-radio-group v-model="searchArr.status" size="mini">
                                <el-radio-button :label="1">服务中</el-radio-button>
                                <el-radio-button :label="2">本月到期</el-radio-button>
                                <el-radio-button :label="3">已经过期</el-radio-button>
                            </el-radio-group>
                        </el-form-item> -->
                        <!-- <el-form-item label="到期时间" prop="expire_date" id="expire_date">
                            <el-date-picker size="mini" v-model="searchArr.expire_date" type="datetimerange" align="right"
                                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </el-form-item> -->
                        <el-form-item label="人员选择" prop="salesman_id">
                            <el-select v-model="searchArr.salesman_id" placeholder="请选择" filterable clearable size="mini"
                                multiple style="width: 100%;" @click.native="loadAdminUser">
                                <el-option v-for="user in adminUserOptions" :key="user.id" :label="user.username"
                                    :value="user.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="共享人" prop="share_id">
                            <el-select v-model="searchArr.share_id" placeholder="请选择" filterable clearable size="mini"
                                multiable style="width: 100%;" @click.native="loadAdminUser" multiple>
                                <el-option v-for="user in adminUserOptions" :key="user.id" :label="user.username"
                                    :value="user.id"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item label="支付人/手机号" prop="payuser_id">
                <el-input v-model="searchArr.payuser_id" size="mini"
                  placeholder="支付人 / 手机号"></el-input>
              </el-form-item> -->
                        <!-- <el-form-item label="创建时间" prop="created_at">
                <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                  align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-form-item> -->
                        <el-form-item style="text-align: right;margin-right:0.3rem">
                            <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button slot="reference" size="mini">筛选</el-button>
                </el-popover>
            </div>
            <!-- <div style="text-align: right; flex: 1">
          <el-button type="primary" size="mini" @click="categoryIn">录入</el-button>
        </div> -->
        </div>
        <!-- <el-tabs v-model="orderStatusTab" @tab-click="handleClick">
            <el-tab-pane label="全部订单" name="first"></el-tab-pane>
            <el-tab-pane label="已支付" name="second"></el-tab-pane>
            <el-tab-pane label="未支付" name="third"></el-tab-pane>
        </el-tabs> -->
        <el-table max-height="650" :data="tableData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem'
            }" id="forStyle">
            <!-- <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="录入人">
                <span>{{ scope.row.typeiner_name ? scope.row.typeiner_name: '' }}</span>
              </el-form-item>
              <el-form-item label="应聘者简历">
                <el-image
                  v-if="scope.row.biographical_url && scope.row.biographical_url.image_info.is_img"
                  style="width: 200px; height: 200px"
                  :src="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                  :preview-src-list="scope.row.biographical_url ? [scope.row.biographical_url.image_info.url] : []">
                </el-image>
                <el-tooltip v-else class="item" effect="dark"
                  :content="scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' "
                  placement="top">
                  <el-link type="primary" style="cursor:pointer"
                    :href="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                    target="_blank">
                    <span
                      style="width:200px;display:block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden">{{ scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' }}</span>
                  </el-link>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column> -->
            <!-- <el-table-column prop="id" label="ID" fixed>
            </el-table-column> -->
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="order_num" label="订单编号" width="200">
                <template slot-scope="scope">
                    <el-link @click="openOrderInfoDrawer(scope.row)">{{
                        scope.row.order_num }}</el-link>
                </template>
            </el-table-column>
            <el-table-column v-if="titleName !== '今日续费金额'" prop="assign_at" label="派单时间" width="135">
                <!-- <template slot-scope="scope">
                    <el-link @click="openOrderInfoDrawer(scope.row)">{{
                        scope.row.order_num }}</el-link>
                </template> -->
            </el-table-column>
            <!-- <el-table-column prop="" label="派单时间" width="135">
                <template slot-scope="scope">
                    <span>{{ new Date(scope.row.assign_at).getTime() }}</span>
                    <span>{{ new Date().valueOf() }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="total_amount" label="订单金额(元)" width="150">
                <!-- <template slot-scope="scope">
                    <el-link @click="openCompanyDrawer(scope.row, '所有待续费客户', 'wait_to_renew_company_ids')">{{
                        scope.row.wait_to_renew }}个</el-link>
                </template> -->
            </el-table-column>
            <el-table-column prop="company_info.company_name" label="公司名称" width="230">
                <!-- <template slot-scope="scope">
                    <el-link @click="openCompanyDrawer(scope.row, '所有待续费客户', 'wait_to_renew_company_ids')">{{
                        scope.row.wait_to_renew }}个</el-link>
                </template> -->
            </el-table-column>
            <el-table-column prop="" label="企业税种" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.tax_table && scope.row.tax_table.tax_types === 3">一般纳税人</span>
                    <span v-else-if="scope.row.tax_table && scope.row.tax_table.tax_types === 2">小规模</span>
                    <span v-else>未知</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="是否零申报" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.tax_table && scope.row.tax_table.is_zero_declare === 2">否</span>
                    <span v-else-if="scope.row.tax_table && scope.row.tax_table.is_zero_declare === 1">是</span>
                    <span v-else>未知</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="服务时间" width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.fin_table && scope.row.fin_table.start_time">{{ scope.row.fin_table.start_time
                    }}</span>&nbsp;&nbsp;-&nbsp;&nbsp;
                    <span v-if="scope.row.fin_table && scope.row.fin_table.end_time">{{ scope.row.fin_table.end_time
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="是否包含赠送" width="110">
                <template slot-scope="scope">
                    <el-tag type="danger" effect="dark" size="mini"
                        v-if="scope.row.fin_table && scope.row.fin_table.include_gifts === 0">否</el-tag>
                    <div class="div-y" v-else-if="scope.row.fin_table && scope.row.fin_table.include_gifts === 1">
                        <p>是</p>
                        <p>{{ scope.row.fin_table.include_gifts }}个月</p>
                    </div>
                    <span v-else>未知</span>
                </template>
            </el-table-column>
            <el-table-column prop="tax_table.fin_charges" label="收费标准" width="100">
                <!-- <template slot-scope="scope">
                    <el-link @click="openCompanyDrawer(scope.row, '所有待续费客户', 'wait_to_renew_company_ids')">{{
                        scope.row.wait_to_renew }}个</el-link>
                </template> -->
            </el-table-column>
            <el-table-column prop="" label="增值服务" width="210">
                <template slot-scope="scope">
                    <div style="background-color: #F2F6FC;text-align: center;border-radius: 5px;">
                        <div v-if="scope.row.value_added" v-for="item in scope.row.value_added" :key="item.id">
                            <div style="display: flex;justify-content:space-evenly;">
                                <div class="p-name">{{ item.name }}</div>
                                <div class="p-type">{{ item.type }}</div>
                                <div class="p-price">{{ item.price }}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="expire_in_this_month" label="本月到期" width="100">
            </el-table-column>
            <el-table-column prop="already_expired" label="已经过期" width="100">
            </el-table-column>
            <el-table-column prop="today_renew" label="今日续费" width="100">
            </el-table-column>
            <el-table-column prop="today_renew_money_count" label="今日续费金额" width="130">
            </el-table-column>
            <el-table-column prop="this_month_renew" label="本月续费" width="100">
            </el-table-column>
            <el-table-column prop="all_of_renew_money" label="续费金额累计" width="150">
            </el-table-column> -->
            <!-- <el-table-column label="支付状态">
                <template slot-scope="scope">
                    <span>{{ scope.row.status === 0 ? '未支付' : '已支付' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="user_info.phone" label="支付人手机">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.user_info.phone" placement="top">
                        <span class="hide-style"><el-link style="color: #409EFF;cursor: pointer"
                                @click="openPhoneFromDraw(scope.row.user_info.phone)">{{
                                    scope.row.user_info.phone.substring(0, 5) + '...' }}</el-link>
                            <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                                <i @click="makePhone(scope.row.user_info.phone)" class="el-icon-phone-outline"
                                    style="color: #409EFF;cursor:pointer;"></i>
                            </el-tooltip>
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column v-if="needType === 0" prop="paied" label="是否有过支付成功记录">
                <template slot-scope="scope">
                    <span v-if="scope.row.paied === true">是</span>
                    <el-tag v-else type="danger">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column v-if="needType === 0" prop="join_public" label="是否已经加入公海池">
                <template slot-scope="scope">
                    <span v-if="scope.row.join_public === true">是</span>
                    <el-tag v-else type="danger">否</el-tag>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="应聘职位">
          <template slot-scope="scope">
            <span v-if="scope.row.station !== '暂未填写'">{{ scope.row.station }}</span>
            <span v-else style="color:#F56C6C">{{ scope.row.station }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="meet_place" label="面试地点">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.meet_place }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="meet_at" label="面试时间">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.meet_at }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="面试官">
          <template slot-scope="scope">
            <span v-if="scope.row.interviewer_name">
              {{ scope.row.interviewer_name.join(',') }}
            </span>
            <span v-else style="color:#F56C6C">暂未填写</span>
          </template>
        </el-table-column>
        <el-table-column label="飞书链接">
          <template slot-scope="scope">
            <span v-if="scope.row.feishuurl">
              <el-link type="primary" @click.native="openUrl(scope.row.feishuurl)">打开链接</el-link>
            </span>
            <span v-else style="color:#F56C6C">暂未设置链接</span>
          </template>
        </el-table-column> -->
            <!-- <el-table-column prop="created_at" label="创建时间"></el-table-column>
            <el-table-column label="支付时间">
                <template slot-scope="scope">
                    <span>{{ scope.row.send_pay_date ? scope.row.send_pay_date : '---' }}</span>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top"
              v-if="scope.row.status === 3">
              <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
                icon="el-icon-document-checked" circle disabled>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top" v-else>
              <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
                icon="el-icon-document-checked" circle>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="提交反馈" placement="top">
              <el-button @click.native.prevent="openExamineFeed(scope.row.id)" type="warning"
                size="mini" icon="el-icon-finished" circle>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column> -->
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="npage"
                layout="sizes, total, prev, pager, next, jumper" :total="total" :page-sizes="[10, 15, 30, 50, 100]"
                :page-size="categoryPerPage" background>
            </el-pagination>
        </div>
        <el-drawer title="订单信息" :visible.sync="orderInfoVisible" append-to-body direction="rtl" size="50%"
            :before-close="handleOrderInfoClose">
            <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
                <order-info :orderId="orderInfoId"></order-info>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import upfile from '../../../common/UpFile.vue'
import Vue from 'vue'
import CompanyInfo from 'common/CompanyInfo'
import { fscDate } from '../../../../static/mixins/fastChooseDate'
import MakePhone from 'common/MakePhone'
import OrderInfo from 'common/OrderInfo'
export default {
    name: 'RenewOrderList',
    mixins: [fscDate],
    components: { CompanyInfo, upfile, MakePhone, OrderInfo },
    props: {
        order_id: {
            type: Array
        },
        titleName: {
            type: String
        }
    },
    data() {
        Vue.directive('down', {
            inserted: (el, binding) => {
                el.style.cssText = 'cursor: pointer;color:write;'
                el.addEventListener('click', () => {
                    // console.log(binding.value)
                    let link = document.createElement('a')
                    let image = document.createElement('image')
                    let url = binding.value
                    let downloadName = url.slice(url.lastIndexOf('/') + 1)
                    // console.log(downloadName);
                    // 这里是将url转成blob地址，
                    image.setAttribute('crossOrigin', 'anonymous') // 这句可以解决跨域问题
                    fetch(url)
                        .then((res) => res.blob())
                        .then((blob) => {
                            // 将链接地址字符内容转变成blob地址
                            link.href = URL.createObjectURL(blob)
                            // console.log(link.href)
                            link.download = downloadName
                            document.body.appendChild(link)
                            link.click()
                        })
                })
            },
        })
        let checkPhone = (rule, value, callback) => {
            if (value !== '') {
                let reg = /^1[3456789]\d{9}$/
                if (!reg.test(value)) {
                    callback(new Error('请输⼊有效的⼿机号码'))
                }
            }
            callback()
        }
        return {
            visible: false,
            orderInfoVisible: false,
            orderInfoId: null,
            renewCompanyDrawer: false,
            renewCompanyDrawerName: '',
            wait_to_renew_company_ids: [],
            orderStatusTab: 'first',
            phoneFrom_phone: [],
            phoneFromDraw: false,
            timer: '',
            needType: '',
            companyComId: null,
            companyInfoDrawer: false,
            unMatterOveredId: '',
            pageSize_un: 10,
            total_un: 0,
            npage_un: 1,
            unMatterOveredData: [],
            unMatterOveredDrawer: false,
            headers: {
                Authorization: localStorage.getItem('token'),
            },
            change: false,
            aboutExId: '',
            FOptions: [],
            needUrl: [],
            fileList: [],
            limit: 10,
            distributeForm: {
                feedback: '',
                progress: '1',
            },
            examineFeed: {
                remark: '',
            },
            distributeDrawer: false,
            exmined: [],
            examine: [],
            examineId: '',
            examineDialog: false,
            pageSize_inside: 10,
            nowPage_inside: 1,
            total_inside: 0,
            npage_inside: 1,
            examineData: [],
            searchArr: {
                phone_order: '',
                created_at: '',
                salesman_id: '',
                expire_date: '',
                share_id: '',
                status: ''
            },
            adminUserOptions: [],
            npage: 1,
            categoryPerPage: 10,
            total: null,
            listSortForm: [],
            tableData: [],
            searcher: null,
            categoryEditDrawer: false,
            searchLoading: false,
            searchCategories: [],
            categoryIndrawer: false,
            direction: 'rtl',
            ifDisplay: false,
            ListIfDisplay: [],
            listSort: [],
            category: '',
            branch: [],
            options_adminUsers: [],
            typeInPickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24
                },
            },
            categoryForm: {
                name: '',
                phone: '',
                branch_id: '',
                station: '',
                meetAt: '',
                meet_place: '',
                feishuurl: '',
            },
            editCategoryForm: {
                categoryId: '',
                category_name: '',
                display: false,
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkPhone, trigger: 'blur' },
                ],
                meetAt: [
                    { required: true, message: '请选择面试时间', trigger: 'blur' },
                ],
                meet_place: [
                    { required: true, message: '请选择面试地点', trigger: 'blur' },
                ],
                station: [
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                feishuurl: [
                    {
                        min: 1,
                        max: 200,
                        message: '长度在 1 到 200 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        collapse() {
            return this.$store.state.collapse
        },
    },
    mounted() {
        // this.loadTable()
    },
    beforeDestroy() {
        //
    },
    watch: {
        'searchArr.phone_order': {
            handler() {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.npage = 1
                    this.loadTable(this.needType)
                }, 300)
            },
            deep: true,
        },
        order_id(n) {
            this.npage = 1
            this.categoryPerPage = 10
            this.total = 0
            this.clearSome('searchArr')
            this.tableData = []
            if (n.length > 0) {
                this.loadTable()
            }
        }
    },
    methods: {
        loadAdminUser() {
            this.$axios
                .get('api/expmanage/getreceiver')
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.adminUserOptions = data.data
                    }
                })
                .catch()
        },
        openUrl(url) {
            let newPage = this.$router.resolve({
                path: '/documentation',
                query: { url: url },
            })
            window.open(newPage.href, '_blank')
        },
        getAdminUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.options_adminUsers = data.data.users
                    this.roles = data.data.roles
                    this.statistical = data.data.statistical
                }
            })
        },
        getUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.users = data.data.users
                    this.roles = data.data.roles
                    this.branch = data.data.branch
                    this.statistical = data.data.statistical
                }
            })
        },
        copy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success',
            })
        },
        copySome(data) {
            this.copy(data)
        },
        handleSizeChange_un(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_un = val
            this.getUnMatterOveredData()
        },
        handleCurrentChange_un(val) {
            this.npage_un = val
            this.getUnMatterOveredData()
        },
        openCompanyCom(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.id
            })
        },
        openCompanyCom_examine(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.company_id
            })
        },
        closeUnMatterOveredDrawer() {
            this.unMatterOveredId = ''
            this.unMatterOveredData = []
        },
        getUnMatterOveredData() {
            if (!this.unMatterOveredId) return false
            this.$axios
                .get(
                    'api/handover_examine/get_matter_un?page' +
                    this.npage_un +
                    '&perPage=' +
                    this.pageSize_un +
                    '&cid=' +
                    this.unMatterOveredId
                )
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.unMatterOveredData = data.data.data
                        this.total_un = data.data.total
                    }
                })
                .catch()
        },
        openUnMatterOvered(id) {
            this.unMatterOveredId = id
            this.getUnMatterOveredData()
            this.unMatterOveredDrawer = true
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
            const isLt100M = file.size / 1024 / 1024 < 100

            // if (!isJPG) {
            //   this.$message.error('上传图片格式为JPG或PNG!')
            //   return
            // }
            if (!isLt100M) {
                this.$message.error('上传总大小不能超过 100MB!')
                return false
            }
            // return isJPG && isLt2M
        },
        handleAvatarSuccess(res, file) {
            if (res.code === 1) {
                this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
            }
            // this.imageUrl = URL.createObjectURL(file.raw)
        },
        handleAvatarChange(res, file) {
            this.fileList = file
            this.change = true
        },
        handlePictureCardPreview(file) {
            this.fileNameList = file.name
        },
        handleRemove(file, fileList) {
            this.needUrl.map((item, index) => {
                if (item.uid === file.uid) {
                    this.needUrl.splice(index, 1)
                }
            })
            this.fileList = fileList
            this.change = true
        },
        // 监听粘贴操作
        handlePaste(event) {
            const items = (event.clipboardData || window.clipboardData).items
            let file = null
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地')
                return
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                // if (items[i].type.indexOf('image') !== -1) {
                file = items[i].getAsFile()
                // break
                // }
            }
            // if (!file) {
            //   this.$message.error('粘贴内容非图片')
            //   return
            // }
            if (this.fileList.length >= this.limit) {
                this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
                return
            }
            this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
            this.$refs.uploadMutiple.submit() // 提交图片上传队列
        },
        submitDisForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.distributeForm.file = this.needUrl
                    this.distributeForm.id = this.aboutExId
                    this.$axios
                        .post('api/handover_examine/store', this.distributeForm)
                        .then(({ data }) => {
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.distributeDrawer = false
                                this.$refs.distributeForm.resetFields()
                                this.fileList = []
                                this.needUrl = []
                                this.change = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    return false
                }
            })
        },
        handleSizeChange_inside(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_inside = val
            this.loadTable_inside()
        },
        handleCurrentChange_inside(val) {
            this.npage_inside = val
            this.loadTable_inside()
        },
        clearExamineParams() {
            let check = document.getElementsByTagName('input')
            let arr = Array.from(check)
            console.log(arr)
            arr.map((item) => {
                item.checked = false
            })
            // for (var i in this.examine) {
            //   this.examine[i] = false
            // }
            // this.examine.map((item, index) => {
            //   this.examine.splice(index, 1)
            // })
            this.examineId = ''
        },
        loadTable_inside() {
            this.$axios
                .get('api/handover_examine/' + this.examineId, {
                    params: {
                        page: this.npage_inside,
                        perpage: this.pageSize_inside,
                        // searchItem: this.searcher
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.examineData = data.data.data
                        this.total_inside = data.data.total
                        // this.loadRadio()
                        // this.loadSort()
                    }
                })
                .catch()
        },
        examineChange(val, id, index) {
            if (val) {
                this.$axios
                    .put('api/handover_examine/' + this.examineId, {
                        company_id: id,
                    })
                    .then(({ data }) => {
                        if (data.code === 1) {
                            // this.exmined.push(id)
                            // this.examineData[index].is_examined = true
                            this.loadTable_inside()
                            this.loadTable()
                            this.$message.success(data.msg)
                            //   this.examineData = data.data.data
                            //   this.total_inside = data.data.total
                            // this.loadRadio()
                            // this.loadSort()
                        }
                    })
                    .catch()
            }
        },
        openNameRow(id) {
            this.examineId = id
            this.loadTable_inside()
            this.examineDialog = true
        },
        handleClick(val) {
            if (val.name === 'first') {
                this.npage = 1
                this.needType = ''
                this.loadTable()
            }
            if (val.name === 'second') {
                this.npage = 1
                this.needType = 1
                this.loadTable(1)
            }
            if (val.name === 'third') {
                this.needType = 0
                this.npage = 1
                this.loadTable(0)
            }
        },
        openPhoneFromDraw(phone) {
            setTimeout(() => {
                this.phoneFrom_phone.push(phone)
            })
            this.phoneFromDraw = true
        },
        makePhone(phone) {
            // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

            // if (!regPhone.test(phone)) {
            //     this.$message.error('手机号格式错误')
            //     return
            // }
            // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
            this.$axios.post('api/admin/call_logs_call', {
                phone
            }).then((res) => {
                let { data } = res
                if (data.code === 0) {
                    this.$message.success('调用成功，请注意接听来电')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        closePhoneFromDraw(done) {
            this.phoneFrom_phone = []
            done()
        },
        resetForm(formName) {
            this.visible = false
            this.$refs[formName].resetFields()
        },
        doSearch() {
            this.visible = false
            this.npage = 1
            this.loadTable(this.needType)
        },
        openCompanyDrawer(row, name, value) {
            this.renewCompanyDrawer = true
            this.renewCompanyDrawerName = name
            this.value = row.value
        },
        closeRenewCompanyDrawer(done) {
            this.renewCompanyDrawerName = ''
            this.wait_to_renew_company_ids = []
            done()
        },
        clearSome(obj) {
            var arr = Object.keys(this[obj])
            arr.map(item => {
                if (Array.isArray(this[obj][item])) {
                    this[obj][item] = []
                } else {
                    this[obj][item] = ''
                }
            })
        },
        loadTable() {
            this.$axios
                .get('api/ysy_count_get_order_info', {
                    params: {
                        page: this.npage,
                        per_page: this.categoryPerPage,
                        searchItem: this.searchArr,
                        order_id: this.order_id.join(',')
                    },
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.tableData = data.data.data
                        // this.$refs.renewPopover.doClose()
                        this.total = data.data.total
                        // this.loadRadio()
                        // this.loadSort()
                    }
                })
                .catch()
        },
        openOrderInfoDrawer(row) {
            this.orderInfoVisible = true
            this.$nextTick(() => {
                this.orderInfoId = row.id
            });
        },
        handleOrderInfoClose(done) {
            this.orderInfoId = null
            done()
        },
        loadRadio() {
            this.categoryData.map((item) => {
                if (item.display === 1) {
                    this.ListIfDisplay[item.id] = false
                } else {
                    this.ListIfDisplay[item.id] = true
                }
            })
        },
        loadSort() {
            this.categoryData.map((item) => {
                this.listSort[item.id] = Number(item.sort)
            })
        },
        handleCurrentChange(val) {
            this.npage = val
            this.loadTable(this.needType)
        },
        handleSizeChange(val) {
            this.npage = 1
            this.categoryPerPage = val
            this.loadTable()
        },
        editRow(id) {
            this.$axios
                .put('api/handover_examine/all_examined/' + id)
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    }
                })
                .catch()
        },
        searchRemoteCfcategory(query) {
            if (query !== '') {
                this.searchLoading = true
                setTimeout(() => {
                    this.searchLoading = false
                    this.searchItem(query)
                }, 200)
            } else {
                this.searchCategories = []
            }
        },
        searchItem(query) {
            this.$axios
                .get('api/recruit_manage_remote_search', {
                    params: {
                        search: query,
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.searchCategories = data.data
                    }
                })
                .catch()
        },
        handleSearchCfcategory(query) {
            this.searcher = query
            setTimeout(() => {
                this.loadTable()
            })
        },
        categoryIn() {
            this.categoryIndrawer = true
        },
        handleClose(done) {
            this.$refs.categoryForm.resetFields()
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => { })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.categoryForm.file = this.needUrl
                    this.$axios
                        .post('api/recruit_manage_store', this.categoryForm)
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.$refs.categoryForm.resetFields()
                                this.$bus.$emit('ysyclearrm')
                                this.categoryIndrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios
                        .put('api/advicecate/edit', {
                            id: this.category,
                            category_name: this.editCategoryForm.categoryId,
                            display: this.ifDisplay === false ? 1 : 0,
                        })
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.categoryEditDrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editListRadio(row) {
            this.$axios
                .put('api/advicecate/listshow', {
                    id: row.id,
                    display: this.ListIfDisplay[row.id] === false ? 1 : 0,
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        setSort(row) {
            if (isNaN(this.listSort[row.id])) {
                this.$message.error('排序值为数字！')
                return false
            }
            this.$axios
                .put('api/advicecate/setsort', {
                    id: row.id,
                    sort: this.listSort[row.id],
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        handleCloseDis(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    if (this.$refs.distributeForm) {
                        this.$refs.distributeForm.resetFields()
                    }
                    this.fileList = []
                    this.needUrl = []
                    this.change = false
                    this.aboutExId = ''
                    this.distributeForm.progress = 1
                    this.FOptions = []
                    done()
                })
                .catch((_) => { })
        },
        openExamineFeed(id) {
            this.aboutExId = id
            this.$axios
                .get('api/handover_examine/' + id + '/edit')
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.FOptions = data.data
                        let obj = data.data[0]
                        this.distributeForm.progress = obj ? obj.progress : 1
                    }
                })
                .catch()
            this.distributeDrawer = true
        },
    },
}
</script>
<style scoped>
.p-name {
    color: #409EFF;
}

.p-type {
    color: #67C23A;
}

.p-price {
    color: #F56C6C;
}

.div-y {
    background-color: #67C23A;
    border-radius: 5px;
    color: snow;
    text-align: center;
}

.handover_examine {
    /* margin-left: 3.6rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

#forStyle>>>.demo-table-expand {
    font-size: 0;
}

#forStyle>>>.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

#forStyle>>>.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
    display: block;
}

#expire_date>>>.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
    width: 100% !important;
}</style>
  


// WEBPACK FOOTER //
// src/pages/count/common/OrderList.vue